// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/game/chat-background-desktop.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.game__container {
  height: 100dvh;
  width: 100vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}
@media all and (min-width: 1280px) {
  .game__container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}

.chat {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0;
}
@media all and (min-width: 1280px) {
  .chat {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 1rem;
    width: 1000px;
    height: 698px;
  }
}
.chat--vsk {
  background-color: #4544EE;
}
.chat--robo-finance {
  background-color: #00BF6E;
}
.chat--sport-master {
  background-color: #1551E5;
}
.chat--h {
  background-color: #2078FE;
}
.chat--kontur {
  background-color: #1F106D;
}
.chat--alfa-bank {
  background-color: #EF3124;
}
.chat--vtb {
  background-color: #002882;
}
.chat--x-5 {
  background-color: #5FAF2D;
}
.chat__message-area {
  display: flex;
  flex-direction: column;
  grid-gap: 12px;
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE и Edge */
  position: relative;
  height: 100%;
}
.chat__message-area::-webkit-scrollbar {
  display: none;
}
.chat__stepper {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 1.5rem;
  background: linear-gradient(180deg, #151515 -33.54%, rgba(21, 21, 21, 0) 100%);
}
.chat__input {
  padding: 1.5rem;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 10px 1rem;
}
@media all and (min-width: 1280px) {
  .chat-header {
    padding: 1.5rem;
  }
}
.chat-header__container {
  display: flex;
  grid-gap: 12px;
}
.chat-header__inter {
  font-family: "Inter";
}
.chat-header__ai-logo {
  width: 60px;
  height: 60px;
  background-color: darkblue;
  border-radius: 50%;
  overflow: hidden;
}
.chat-header__santa {
  display: flex;
  flex-direction: column;
  grid-gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Game/Game.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,cAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;AAAF;AAEE;EAPF;IAQI,yDAAA;EACF;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EAPF;IAQI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IAEA,mBAAA;IAEA,aAAA;IACA,aAAA;EAAF;AACF;AAEE;EACE,yBCfE;ADeN;AAGE;EACE,yBChBW;ADef;AAIE;EACE,yBClBW;ADgBf;AAKE;EACE,yBC1BA;ADuBJ;AAME;EACE,yBC1Ca;ADsCjB;AAOE;EACE,yBCpCQ;AD+BZ;AAQE;EACE,yBCrCE;AD+BN;AASE;EACE,yBCvCE;ADgCN;AAUE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,cAAA;EACA,kBAAA;EACA,YAAA;AARJ;AAUI;EACE,aAAA;AARN;AAYE;EACE,gBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,8EAAA;AAVJ;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,uBAAA;EACA,kBAAA;AAbF;AAeE;EARF;IASI,eAAA;EAZF;AACF;AAcE;EACE,aAAA;EACA,cAAA;AAZJ;AAeE;EACE,oBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAfJ","sourcesContent":["@import 'src/styles/variables';\n\n.game__container {\n  height: 100dvh;\n  width: 100vw;\n  background-image: url(\"../../../public/game/chat-background-desktop.webp\");\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  @media all and (min-width: $desktop) {\n    background-image: url(\"../../../public/game/chat-background-desktop.webp\");\n  }\n}\n\n.chat {\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 0;\n\n  @media all and (min-width: $desktop) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    border-radius: 1rem;\n\n    width: 1000px;\n    height: 698px;\n  }\n\n  &--vsk {\n    background-color: $vsk;\n  }\n\n  &--robo-finance {\n    background-color: $robo-finance;\n  }\n\n  &--sport-master {\n    background-color: $sport-master;\n  }\n\n  &--h {\n    background-color: $h;\n  }\n\n  &--kontur {\n    background-color: $main-dark-blue;\n  }\n\n  &--alfa-bank {\n    background-color: $alfa-bank;\n  }\n\n  &--vtb {\n    background-color: $vtb;\n  }\n\n  &--x-5 {\n    background-color: $x-5;\n  }\n\n  &__message-area {\n    display: flex;\n    flex-direction: column;\n    grid-gap: 12px;\n    overflow: scroll;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE и Edge */\n    position: relative;\n    height: 100%;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  &__stepper {\n    position: sticky;\n    top: 0;\n    left: 0;\n    width: 100%;\n    padding: 0 1.5rem;\n    background: linear-gradient(180deg, #151515 -33.54%, rgba(21, 21, 21, 0) 100%);\n  }\n\n  &__input {\n    padding: 1.5rem;\n  }\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  background-color: white;\n  padding: 10px 1rem;\n\n  @media all and (min-width: $desktop) {\n    padding: 1.5rem;\n  }\n\n  &__container {\n    display: flex;\n    grid-gap: 12px;\n  }\n\n  &__inter {\n    font-family: \"Inter\";\n  }\n\n  &__ai-logo {\n    width: 60px;\n    height: 60px;\n    background-color: darkblue;\n    border-radius: 50%;\n    overflow: hidden;\n  }\n\n  &__santa {\n    display: flex;\n    flex-direction: column;\n    grid-gap: 4px;\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
